export async function initSteps(_this) {
  const {
    preview,
    offerActive,
    sentences,
    careersUrl,
    alternativeOffers,
    steps,
    mandatorySteps,
  } = _this.props

  if (!preview && offerActive === false) {
    return {
      rawSteps: [
        unavailableOfferStep(
          sentences.offerUnavailable,
          careersUrl,
          alternativeOffers,
        ),
      ],
    }
  }

  const rawSteps = []
  let startSteps = []
  let endSteps = []

  const existingConversation = null

  const indexPlaceholder = mandatorySteps
    .map((step) => step.type)
    .indexOf('placeholder')

  if (indexPlaceholder > 0) {
    startSteps = mandatorySteps.slice(0, indexPlaceholder)

    if (mandatorySteps.length > indexPlaceholder) {
      endSteps = mandatorySteps.slice(indexPlaceholder + 1)
    }
  } else {
    startSteps = mandatorySteps
  }



  //   const { data, total } = conversation

  //   if (total > 0) {
  //     existingConversation = data[0]

  //     const tokenStep = existingTokenStep(candidate)

  //     rawSteps.push(tokenStep)

  //     startSteps.forEach((step) => {
  //       if (
  //         step.condition === undefined
  //         || step.condition.step_id === undefined
  //       ) {
  //         step.condition = {
  //           step_id: tokenStep._id,
  //           values: [tokenStep.options[1]._id],
  //         }
  //       }
  //     })
  //   }
  // }

  // const availableMessagingPlatforms = {
  //   messenger: !!(_this.props.messengerAppId && _this.props.messengerPageId && _this.props.messengerActive),
  //   whatsapp: false,
  //   sms: !!(_this.props.phoneNumber && _this.props.phoneActive),
  //   mail: true,
  // }

  rawSteps.push(
    ...startSteps,
    ...steps,
    // ...messagingPlatformSteps(availableMessagingPlatforms, sentences),
    ...endSteps,
  )

  rawSteps[rawSteps.length - 1].type = 'textfield'
  rawSteps[rawSteps.length - 1]._id = 'candidateQuestion'

  return {
    rawSteps,
    existingConversation,
  }
}

export const candidateQuestionAnswerStep = (sentence) => ({
  _id: 'candidateQuestionAnswer',
  type: 'text',
  sentence:
    sentence ||
    'Je suis désolé, nous sommes arrivés à la fin de votre candidature. Nous vous souhaitons une belle journée.',
})

export const existingTokenStep = (candidate) => {
  let { firstname, lastname, email } = candidate

  firstname = firstname.charAt(0).toUpperCase() + firstname.slice(1)
  lastname = lastname.charAt(0).toUpperCase() + lastname.slice(1)

  return {
    _id: 'checkCandidate',
    type: 'qcm',
    sentence: `Bonjour. Avant de débuter est-ce qu'il s'agit bien de ${firstname} ${lastname} dont l'adresse email est ${email} ?`,
    options: [
      {
        _id: 'checkCandidate-true',
        label: "Oui, c'est bien moi",
      },
      {
        _id: 'checkCandidate-false',
        label: "Non, c'est incorrect",
      },
    ],
  }
}

export const unavailableOfferStep = (
  sentence,
  careersUrl,
  alternativeOffers,
) => {
  if (careersUrl) {
    sentence = `${sentence}\n\nNous avons d'autres offres disponibles sur le site ${careersUrl} .`
  }

  if (alternativeOffers) {
    const applyUrl = process.env.REACT_APP_APPLY_URL || 'http://localhost:3002'
    sentence = `${sentence}\n\nVoici quelques une de nos offres actuellement disponibles : \n${alternativeOffers
      .map(
        (offer) =>
          `<li>${applyUrl}/${offer._id}:name=${offer.name
            .replace(/\s\s+/g, ' ')
            .replace(/ /g, '_*_')}`,
      )
      .join(' ')}</li>`
  }

  return {
    _id: 'unavailableOffer',
    type: 'text',
    sentence,
  }
}

export const messagingPlatformSteps = (
  availableMessagingPlatforms,
  sentences = {},
) => {
  const { reengagementPlatform, askNumberSms, confirmPlatform } = sentences

  const steps = [
    {
      _id: 'messagingPlatform',
      type: 'qcm',
      sentence:
        reengagementPlatform ||
        'Sur quel canal préféreriez vous être recontacté pour nos futurs échanges ?',
      options: [],
    },
    {
      _id: 'askPhoneNumber',
      condition: {
        step_id: 'messagingPlatform',
        values: ['sms'],
      },
      type: 'textfield',
      placeholder: '+33655596109',
      errorMessage: 'Entrez un numéro au format +33655596109',
      sentence: askNumberSms || 'A quel numéro peut-on vous recontacter ?',
    },
    {
      _id: 'confirmMessagingPlatform',
      type: 'text',
      sentence:
        confirmPlatform ||
        'Le choix de la platforme a bien été pris en compte, la suite des échanges se fera via le canal sélectionné',
    },
  ]

  for (const i in availableMessagingPlatforms) {
    if (availableMessagingPlatforms[i]) {
      if (i === 'messenger') {
        steps[0].options.push({
          _id: 'messenger',
          label: 'Messenger',
        })
      }
      if (i === 'whatsapp') {
        steps[0].options.push({
          _id: 'whatsapp',
          label: 'Whatsapp',
        })
      }
      if (i === 'sms') {
        steps[0].options.push({
          _id: 'sms',
          label: 'SMS',
        })
      }
      if (i === 'mail') {
        steps[0].options.push({
          _id: 'mail',
          label: 'Mail',
        })
      }
    }
  }

  if (steps[0].options.length > 1) {
    return steps
  }
  return []
}

export const formatSentence = (sentence) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g
  return sentence.replace(urlRegex, (url) => {
    if (url.includes(':name=')) {
      const index = url.indexOf(':name=')
      const onlyUrl = url.substring(0, index)
      const name = url.substring(index + 6)

      return `<a href="${onlyUrl}" target="_blank">${name.replace(
        /_\*_/g,
        ' ',
      )}</a>`
    }
    return `<a href="${url}" target="_blank">${url}</a>`
  })
}

export const formatStep = (step, sentences) => {
  if (typeof step !== 'object') {
    console.error('not an object')
    return null
  }

  let cfStep

  if (step.type === 'text') {
    cfStep = {
      tag: 'cf-robot-message',
      type: 'text',
      name: step._id,
      id: step._id,
      'cf-input-placeholder': 'Répondre',
      'cf-questions': formatSentence(step.sentence),
    }
  }

  if (step.type === 'textfield') {
    if (step.requirement === 'Téléphone') {
      cfStep = {
        tag: 'input',
        type: 'text',
        name: step._id,
        id: step._id,
        'cf-prevent-autofocus': false,
        'cf-questions': formatSentence(step.sentence),
        'cf-input-placeholder': '+33655596109',
        'cf-error': 'Entrez un numéro au format +33655596109',
        required: true,
      }
    } else {
      let maxlength
      let errorMessage = 'Répondre'

      if (step.requirement === 'Prénom' || step.requirement === 'Nom') {
        maxlength = 50
        errorMessage = 'Répondre (max. 50 chars.)'
      }

      cfStep = {
        tag: 'input',
        type: 'text',
        name: step._id,
        id: step._id,
        'cf-prevent-autofocus': false,
        'cf-questions': formatSentence(step.sentence),
        'cf-input-placeholder': step.placeholder || 'Répondre',
        'cf-error': step.errorMessage || sentences.missingInput || errorMessage,
        required: true,
        ...(maxlength ? { maxlength } : {}),
      }
    }
  }

  if (step.type === 'qcm') {
    if (step.options.length > 8) {
      cfStep = {
        tag: 'input',
        type: 'text',
        name: step._id,
        id: step._id,
        'cf-prevent-autofocus': false,
        'cf-questions': formatSentence(step.sentence),
        'cf-input-placeholder': step.placeholder || 'Sélectionner une option',
        'cf-error': step.errorMessage || sentences.missingInput,
        required: true,
        list: step._id,
      }
    } else {
      cfStep = {
        tag: 'select',
        name: step._id,
        id: step._id,
        'cf-questions': formatSentence(step.sentence),
        'cf-prevent-autofocus': true,
        isMultiChoice: false,
        children: step.options.map((option) => ({
          name: option._id,
          tag: 'option',
          'cf-label': option.label,
          value: option._id,
        })),
        'cf-error': sentences.missingInput || 'Répondre',
        required: true,
      }
    }
  }

  if (step.type === 'datefield') {
    cfStep = {
      tag: 'input',
      type: 'date',
      name: step._id,
      id: step._id,
      'cf-questions': formatSentence(step.sentence),
      'cf-input-placeholder': 'Répondre',
      'cf-error': sentences.missingInput || 'Répondre',
      required: true,
    }
  }

  if (step.type === 'salaryfield') {
    const min = 0 // Math.min(...step.numberScores.map((option) => option.minValue))
    const max = 1000000 // Math.max(...step.numberScores.map((option) => option.maxValue))

    cfStep = {
      tag: 'input',
      type: 'number',
      name: step._id,
      id: step._id,
      'cf-questions': formatSentence(step.sentence),
      'cf-input-placeholder': step.placeholder || 'Répondre',
      'cf-error': `La valeur doit être comprise entre ${min} et ${max}`,
      required: true,
      min,
      max: max - 0.00000001,
    }
  }

  if (step.type === 'numberfield') {
    const min = Math.min(...step.numberScores.map((option) => option.minValue))
    const max = Math.max(...step.numberScores.map((option) => option.maxValue))

    cfStep = {
      tag: 'input',
      type: 'number',
      name: step._id,
      id: step._id,
      'cf-questions': formatSentence(step.sentence),
      'cf-input-placeholder': step.placeholder || 'Répondre',
      'cf-error': `La valeur doit être comprise entre ${min} et ${max}`,
      required: true,
      min,
      max: max - 0.00000001,
    }
  }

  if (step.type === 'mailfield') {
    cfStep = {
      tag: 'input',
      type: 'email',
      name: step._id,
      id: step._id,
      'cf-questions': formatSentence(step.sentence),
      'cf-input-placeholder': 'john.doe@gmail.com',
      'cf-error': sentences.missingInput || 'Répondre (max. 120 chars.)',
      maxlength: 120,
      required: true,
    }
  }

  if (step.type === 'attachment') {
    cfStep = {
      tag: 'input',
      accept:
        'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/png,image/jpg,image/jpeg',
      type: 'file',
      name: step._id,
      id: step._id,
      'cf-questions': formatSentence(step.sentence),
      'cf-error': sentences.missingInput || 'Répondre',
      required: true,
    }
  }

  if (step.type === 'video') {
    cfStep = {
      tag: 'select',
      name: step._id,
      id: step._id,
      'cf-prevent-autofocus': true,
      isMultiChoice: false,
      'cf-questions': formatSentence(step.sentence),
      children: [
        {
          name: 'playVideo',
          tag: 'option',
          'cf-label': 'Lancer la vidéo',
          value: 'playVideo',
        },
      ],
      'cf-error': sentences.missingInput || 'Répondre',
      required: true,
    }
  }

  if (step.type === 'show_offers') {
    cfStep = {
      tag: 'cf-robot-message',
      type: 'offers',
      name: step._id,
      id: step._id,
      'cf-prevent-autofocus': true,
      isMultiChoice: false,
      'cf-questions': formatSentence(step.sentence),
      'cf-image':
        'https://cdn.uconnectlabs.com/wp-content/uploads/sites/7/2016/07/how-to-convince-candidate-to-accept-job-offer-840x560.jpg?v=15711',
      'cf-data': JSON.stringify(
        step.offers.map((offer) => ({
          id: offer._id,
          name: offer.name,
          contractType: offer.contractType,
          location: offer.location,
          date: new Date(offer.createdAt).toLocaleDateString(),
        })),
      ),
      'cf-error': sentences.missingInput || 'Répondre',
      required: true,
    }
  }

  return cfStep
}
